module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_24.6bb6da17.jpg";